import React from 'react';

import GhaModel from '../../../models/Gha';

import style from './ghaInfo.module.css';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Info from '@material-ui/icons/Info';
import Videocam from '@material-ui/icons/Videocam';

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: 'white',
      '&:hover': {
        cursor: 'pointer'
      },
      padding: '0px'
    },
    videocam: {
      fontSize: '32px', 
      paddingRight: '5px',
    },
    infoIcon: {
      fontSize: '28px',
      paddingLeft: '5px',
    },
    marginTop8px: {
      marginTop: '8px'
    }
  });

interface GhaInfoProps { 
  classes: any;
  gha: GhaModel;
  handleOpenModalInfo: () => void;
  handleOpenDockOverloadModal: () => void;
};

const ghaInfo = (props: GhaInfoProps) => {

  return (
    <div className={ `${ style.wrapper } ${ style.wrapperfwd }` }> 
      <div className={ style.ghaInfoWrapper }>
        <div className={style.iconWrapper}>
          <Videocam color="primary" className={[ props.classes.materialIcon, props.classes.videocam ].join(' ')} onClick={ props.handleOpenDockOverloadModal } /> 
        </div>
        <div className={ style.info }>
          <p className={ style.name }>{ props.gha.info.name }</p>
          <p className={ style.address }>{ props.gha.info.address }</p>   
        </div>
        <div className={style.iconWrapper}> 
          <Info className={[ props.classes.materialIcon, props.classes.infoIcon ].join(' ')} onClick={ props.handleOpenModalInfo } />
        </div>
      </div>
      <p className={ style.ticker }>
        <span>{ props.gha.info.ticker }</span> 
      </p>
    </div>
  )
};

export default withStyles(styles)(ghaInfo);
